<template>
  <div class="wrapper">
    <h4 :style="{ fontSize: fontSize.h4 + 'em' }">
      {{ items.length ? "延伸閱讀:" : "關鍵字:" }}
    </h4>
    <div class="tabs">
      <div class="tab" v-for="tab in keywords" :key="tab">#{{ tab }}</div>
    </div>
    <div class="items" v-if="items.length">
      <div
        v-for="item in items"
        :key="item.id"
        :class="{
          article: !item.isVideo && !item.isPageVideo,
          video: item.isVideo || item.isPageVideo,
        }"
        class="item"
      >
        <template v-if="item.isVideo">
          <router-link
            :to="{
              name: 'VideoInner',
              params: { id: item.id },
            }"
          >
            <div class="video_box">
              <div class="iframe">
                <div v-if="item.path" v-html="item.path"></div>
                <div v-else>
                  <img :src="fakeVideo" alt="" />
                </div>
              </div>
            </div>

            <h5 :style="{ fontSize: fontSize.h4 + 'em' }">
              {{ item.title }}
            </h5>
          </router-link>
        </template>
        <!-- <template v-else-if="item.isPageVideo">
          <router-link
            :to="{
              name: routePage(item.nodeName),
              params: { pageId: item.id },
            }"
          >
            <div class="video_box">
              <div class="iframe">
                <div v-if="item.path" v-html="item.path"></div>
                <div v-else>
                  <img :src="fakeVideo" alt="" />
                </div>
              </div>
            </div>
            <h5 :style="{ fontSize: fontSize.h4 + 'em' }">
              {{ "[" + item.nodeName + "]" + item.title }}
            </h5>
          </router-link>
        </template> -->
        <template v-else>
          <router-link
            :to="{
              name: routePage(item.nodeName),
              params: { pageId: item.id },
            }"
          >
            <div class="video_box" v-if="item.isPageVideo">
              <div class="iframe">
                <div v-if="item.path" v-html="item.path"></div>
                <div v-else>
                  <img :src="fakeVideo" alt="" />
                </div>
              </div>
            </div>
            <img
              v-else
              :src="item.path ? item.path : fakeImg"
              :alt="item.nodeName + '文章圖片'"
            />
            <h5 :style="{ fontSize: fontSize.h4 + 'em' }">
              {{ "[" + item.nodeName + "]" + item.title }}
            </h5>
          </router-link>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { inject } from "vue";
import { fakeVideo } from "@/fake_data.js";
import { fakeImg } from "@/fake_data.js";

export default {
  name: "FurtherReading",
  props: {
    keywords: Array,
    items: Array,
  },
  components: {},
  setup() {
    let fontSize = inject("fontSize");

    const routePage = (articleType) => {
      switch (articleType) {
        case "新聞轉載":
        case "國際趨勢":
          return "News_page";
        case "專家建議":
          return "ArticlePage";
        case "達人投稿":
          return "SubmitPage";
        case "職場資訊":
        case "返國就業":
        case "返國創業":
          return "Employment";
        default:
          return "News_page";
      }
    };

    return {
      fontSize,
      fakeVideo,
      routePage,
      fakeImg,
    };
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  padding: 40px 0;
  h4 {
    text-align: start;
    margin-bottom: 10px;
  }
  .tabs {
    display: flex;
    margin-bottom: 20px;

    .tab {
      border: 2px dashed #41719c;
      border-radius: 4px;
      padding: 5px 10px;
      margin-right: 10px;
    }
  }
  .items {
    display: flex;
    justify-content: space-around;

    @include md {
      flex-direction: column;
      justify-content: flex-start;
    }

    .item {
      width: 32%;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 40px;

      @include md {
        width: 100%;
      }
    }

    a {
      height: 252px;
      width: 100%;
      @include xl {
        height: 180px;
      }

      @include lg {
        height: 140px;
      }

      @include md {
        height: auto;
      }

      img {
        height: 100%;
        object-fit: contain;
      }

      .video_box {
        height: 100%;
        display: flex;
        align-items: center;

        .iframe {
          position: relative;
          width: 100%;
          aspect-ratio: 16 / 9;

          :deep iframe {
            border-radius: 10px;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            max-height: 100%;
          }
        }
      }
    }
  }
}
</style>
